// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OtherTask_other_task_button_container__OpnjB {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.5rem;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  justify-content: center;
  align-items: center;
}

.OtherTask_other_task_button_container__OpnjB button {
  background-color: #3b82f6;
  color: white;
  padding: 0.75rem 1.25rem;
  font-size: 0.875rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.OtherTask_other_task_button_container__OpnjB button:hover {
  background-color: #2563eb;
}

@media (max-width: 768px) {
  .OtherTask_other_task_button_container__OpnjB {
    padding: 1rem;
    gap: 0.75rem;
    flex-direction: column;
    align-items: stretch;
  }

  .OtherTask_other_task_button_container__OpnjB button {
    width: 100%;
    font-size: 0.8rem;
    padding: 0.6rem 1rem;
  }
}

@media (max-width: 480px) {
  .OtherTask_other_task_button_container__OpnjB {
    padding: 0.75rem;
    gap: 0.5rem;
  }

  .OtherTask_other_task_button_container__OpnjB button {
    font-size: 0.75rem;
    padding: 0.5rem 0.8rem;
  }
}

.OtherTask_extra_field_form__overlay__36eKh {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  padding: 20px;
}

.OtherTask_extra_field_form__container__UcXcL {
  background-color: #fff;
  padding: 24px;
  border-radius: 10px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
}

.OtherTask_extra_field_form__title__pbAbJ {
  font-size: 1.5rem;
  margin-bottom: 16px;
  font-weight: bold;
  text-align: center;
}

.OtherTask_extra_field_form__input__Klpp9,
.OtherTask_extra_field_form__textarea__DHVqI {
  width: 100%;
  padding: 10px 12px;
  margin-bottom: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 15px;
}

.OtherTask_extra_field_form__textarea__DHVqI {
  height: 70px;
  resize: vertical;
}

.OtherTask_extra_field_form__checkbox_group_row__8QPm5 {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.OtherTask_extra_field_form__actions__HIP8p {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

.OtherTask_extra_field_form__cancel_button__Xzivn,
.OtherTask_extra_field_form__submit_button__f9Rk2 {
  padding: 10px 18px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 15px;
}

.OtherTask_extra_field_form__cancel_button__Xzivn {
  background-color: #aaa;
  color: #fff;
}

.OtherTask_extra_field_form__submit_button__f9Rk2 {
  background-color: #28a745;
  color: #fff;
}

@media (max-width: 480px) {
  .OtherTask_extra_field_form__container__UcXcL {
    padding: 16px;
    max-width: 95%;
  }

  .OtherTask_extra_field_form__title__pbAbJ {
    font-size: 1.25rem;
  }

  .OtherTask_extra_field_form__input__Klpp9,
  .OtherTask_extra_field_form__textarea__DHVqI {
    font-size: 14px;
  }

  .OtherTask_extra_field_form__cancel_button__Xzivn,
  .OtherTask_extra_field_form__submit_button__f9Rk2 {
    width: 100%;
    justify-content: center;
  }

  .OtherTask_extra_field_form__actions__HIP8p {
    flex-direction: column;
    align-items: stretch;
  }

  .OtherTask_extra-field-form__checkbox-row__dbgUN {
    flex-direction: column;
    gap: 10px;
  }
}

@media (max-width: 768px) {
  .OtherTask_extra_field_form__container__UcXcL {
    max-width: 90%;
  }

  .OtherTask_extra_field_form__input__Klpp9,
  .OtherTask_extra_field_form__textarea__DHVqI {
    font-size: 14px;
  }

  .OtherTask_extra_field_form__actions__HIP8p {
    flex-direction: column;
    align-items: stretch;
  }

  .OtherTask_extra_field_form__cancel_button__Xzivn,
  .OtherTask_extra_field_form__submit_button__f9Rk2 {
    width: 100%;
  }
}

/* *************** */
.OtherTask_nwepricingdataEditOverlay__azcuk {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.OtherTask_nwepricingdataEdit__dOU-s {
  background-color: #ffffff;
  padding: 2rem;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  font-family: "Segoe UI", sans-serif;
  height: 500px;
  overflow: auto;
}

.OtherTask_nwepricingdataEdit__dOU-s h2 {
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: #111827;
}

.OtherTask_nwepricingdataEdit__dOU-s p {
  font-size: 0.95rem;
  margin: 0.4rem 0;
  color: #374151;
}

.OtherTask_updateButton__rGdbm {
  background-color: #10b981;
  color: white;
  padding: 0.6rem 1.2rem;
  border: none;
  border-radius: 6px;
  margin-top: 1rem;
  margin-right: 0.5rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.OtherTask_updateButton__rGdbm:hover {
  background-color: #059669;
}

.OtherTask_closeButton__lak5w {
  background-color: #ef4444;
  color: white;
  padding: 0.6rem 1.2rem;
  border: none;
  border-radius: 6px;
  margin-top: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.OtherTask_closeButton__lak5w:hover {
  background-color: #dc2626;
}

@media (max-width: 480px) {
  .OtherTask_nwepricingdataEdit__dOU-s {
    padding: 1rem;
    font-size: 0.85rem;
  }

  .OtherTask_nwepricingdataEdit__dOU-s h2 {
    font-size: 1rem;
  }

  .OtherTask_updateButton__rGdbm,
  .OtherTask_closeButton__lak5w {
    width: 100%;
    margin-top: 0.75rem;
  }
}
/* ******* */
.OtherTask_updateexistingprices__quFMv {
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 600px;
  margin: auto;
}

.OtherTask_updateexistingprices__title__\\+zXI3 {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: center;
}

.OtherTask_updateexistingprices__field__4M70m {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}

.OtherTask_updateexistingprices__label__pTsjT {
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.OtherTask_updateexistingprices__input__EGZ74 {
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 8px;
}

.OtherTask_updateexistingprices__actions__T2Q3T {
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
}

.OtherTask_updateexistingprices__save__BEZY0 {
  background-color: #28a745;
  color: #fff;
  padding: 0.75rem 1.25rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.OtherTask_updateexistingprices__cancel__I8Gau {
  background-color: #dc3545;
  color: #fff;
  padding: 0.75rem 1.25rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

/* updare pricing or get  */
.OtherTask_showupdatePricedata_card__JyopA {
  background-color: #fdfdfd;
  border-radius: 10px;
  padding: 20px;
  margin: 20px auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 600px;
}

.OtherTask_showupdatePricedata_title__xRvub {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
}

.OtherTask_showupdatePricedata_card__JyopA p {
  margin: 6px 0;
  font-size: 14px;
  color: #444;
}

.OtherTask_showupdatePricedata_update_button__2SsiZ {
  margin-top: 20px;
  background-color: #007bff;
  color: white;
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.OtherTask_showupdatePricedata_update_button__2SsiZ:hover {
  background-color: #0056b3;
}
.OtherTask_showupdatePricedata_close_button__SELXh {
  margin-top: 20px;
  background-color: #dc3545;
  color: white;
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-left: 8px;
}
.OtherTask_showupdatePricedata_close_button__SELXh:hover {
  background-color: #c82333;
}
/* update extra need */
.OtherTask_updateextraneed_form__6eDpX {
  background-color: #fff;
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 800px;
  margin: auto;
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.OtherTask_updateextraneed_title__R0vZ\\+ {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin-bottom: 1rem;
}

.OtherTask_updateextraneed_grid__FZBCh {
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 1fr;
}

.OtherTask_updateextraneed_grid__FZBCh input[type="text"] {
  padding: 0.75rem;
  font-size: 1rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  width: 100%;
  box-sizing: border-box;
}

.OtherTask_updateextraneed_checkboxLabel__T7Qdg {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  color: #444;
}

.OtherTask_updateextraneed_buttons__6EANp {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.OtherTask_updateextraneed_updateBtn__bVDtt {
  background-color: #4caf50;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  flex: 1 1;
}

.OtherTask_updateextraneed_cancelBtn__vOehZ {
  background-color: #f44336;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  flex: 1 1;
}

@media (max-width: 768px) {
  .OtherTask_updateextraneed_grid__FZBCh {
    grid-template-columns: 1fr;
  }

  .OtherTask_updateextraneed_buttons__6EANp {
    flex-direction: column;
  }
}
/* task */
.OtherTask_salestasks_form__h1sfM {
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.OtherTask_salestasks_title__G9ZY3 {
  font-size: 1.8rem;
  text-align: center;
  color: #333;
}

.OtherTask_salestasks_card__\\+BkBh {
  border: 1px solid #ddd;
  padding: 1.5rem;
  border-radius: 10px;
  background: #f9f9f9;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.OtherTask_salestasks_card__\\+BkBh h3 {
  font-size: 1.2rem;
  margin: 0;
}

.OtherTask_salestasks_card__\\+BkBh input[type="text"],
.OtherTask_salestasks_card__\\+BkBh input[type="date"],
.OtherTask_salestasks_card__\\+BkBh input[type="time"] {
  padding: 0.6rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 1rem;
  width: 100%;
}

.OtherTask_salestasks_checkboxLabel__gigJV {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
}

.OtherTask_salestasks_submitBtn__k938\\+ {
  padding: 10px 15px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1.1rem;
  cursor: pointer;
  align-self: center;
}
.OtherTask_salestasks_buttons__b5\\+7P {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.OtherTask_salestasks_closeBtn__Dsrlj {
  padding: 10px 15px;

  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1.1rem;
  cursor: pointer;
  align-self: center;
}
@media (max-width: 768px) {
  .OtherTask_salestasks_form__h1sfM {
    padding: 1rem;
  }
}

/* view task css */
.OtherTask_taskgetData_container__JmB9t {
  padding: 1rem;
  background: #f1f5f9;
  border-radius: 1rem;
  max-width: 1200px;
  margin: auto;
}

.OtherTask_taskgetData_header__8Clys {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.OtherTask_taskgetData_title__MmETZ {
  font-size: 1.75rem;
  margin-bottom: 0.5rem;
}

.OtherTask_taskgetData_closeBtn__9sYc2 {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #333;
}

.OtherTask_taskgetData_card__dkg6G {
  background: #ffffff;
  border: 1px solid #ddd;
  padding: 1rem;
  margin: 1rem 0;
  border-radius: 0.75rem;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.OtherTask_taskgetData_taskName__MmZZ\\+ {
  font-size: 1.25rem;
  margin: 0.5rem 0;
}

.OtherTask_taskgetData_description__TLwtm {
  font-size: 1rem;
  color: #555;
}

.OtherTask_taskgetData_completed__zT8j4 {
  color: green;
  font-weight: bold;
}

.OtherTask_taskgetData_incomplete__dSmir {
  color: red;
  font-weight: bold;
}

@media (max-width: 768px) {
  .OtherTask_taskgetData_card__dkg6G {
    padding: 0.75rem;
  }

  .OtherTask_taskgetData_title__MmETZ {
    font-size: 1.5rem;
  }

  .OtherTask_taskgetData_taskName__MmZZ\\+ {
    font-size: 1.1rem;
  }

  .OtherTask_taskgetData_description__TLwtm {
    font-size: 0.95rem;
  }

  .OtherTask_taskgetData_closeBtn__9sYc2 {
    font-size: 1.25rem;
  }
}

@media (max-width: 480px) {
  .OtherTask_taskgetData_container__JmB9t {
    padding: 0.5rem;
  }

  .OtherTask_taskgetData_title__MmETZ {
    font-size: 1.25rem;
  }

  .OtherTask_taskgetData_card__dkg6G {
    margin: 0.75rem 0;
    padding: 0.5rem;
  }

  .OtherTask_taskgetData_closeBtn__9sYc2 {
    font-size: 1.1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/OtherTask.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,2CAA2C;EAC3C,mCAAmC;EACnC,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,mBAAmB;EACrB;AACF;AACA,YAAY;AACZ;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA,sBAAsB;AACtB;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,SAAO;AACT;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF;AACA,SAAS;AACT;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;;;EAGE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA;EACE,kBAAkB;;EAElB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".other_task_button_container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1.5rem;\n  background-color: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  justify-content: center;\n  align-items: center;\n}\n\n.other_task_button_container button {\n  background-color: #3b82f6;\n  color: white;\n  padding: 0.75rem 1.25rem;\n  font-size: 0.875rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.other_task_button_container button:hover {\n  background-color: #2563eb;\n}\n\n@media (max-width: 768px) {\n  .other_task_button_container {\n    padding: 1rem;\n    gap: 0.75rem;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .other_task_button_container button {\n    width: 100%;\n    font-size: 0.8rem;\n    padding: 0.6rem 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .other_task_button_container {\n    padding: 0.75rem;\n    gap: 0.5rem;\n  }\n\n  .other_task_button_container button {\n    font-size: 0.75rem;\n    padding: 0.5rem 0.8rem;\n  }\n}\n\n.extra_field_form__overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999;\n  padding: 20px;\n}\n\n.extra_field_form__container {\n  background-color: #fff;\n  padding: 24px;\n  border-radius: 10px;\n  width: 100%;\n  max-width: 500px;\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);\n  box-sizing: border-box;\n}\n\n.extra_field_form__title {\n  font-size: 1.5rem;\n  margin-bottom: 16px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.extra_field_form__input,\n.extra_field_form__textarea {\n  width: 100%;\n  padding: 10px 12px;\n  margin-bottom: 14px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 15px;\n}\n\n.extra_field_form__textarea {\n  height: 70px;\n  resize: vertical;\n}\n\n.extra_field_form__checkbox_group_row {\n  display: flex;\n  justify-content: space-between;\n  gap: 20px;\n  margin-bottom: 14px;\n  flex-wrap: wrap;\n}\n\n.extra_field_form__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.extra_field_form__cancel_button,\n.extra_field_form__submit_button {\n  padding: 10px 18px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 15px;\n}\n\n.extra_field_form__cancel_button {\n  background-color: #aaa;\n  color: #fff;\n}\n\n.extra_field_form__submit_button {\n  background-color: #28a745;\n  color: #fff;\n}\n\n@media (max-width: 480px) {\n  .extra_field_form__container {\n    padding: 16px;\n    max-width: 95%;\n  }\n\n  .extra_field_form__title {\n    font-size: 1.25rem;\n  }\n\n  .extra_field_form__input,\n  .extra_field_form__textarea {\n    font-size: 14px;\n  }\n\n  .extra_field_form__cancel_button,\n  .extra_field_form__submit_button {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .extra_field_form__actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .extra-field-form__checkbox-row {\n    flex-direction: column;\n    gap: 10px;\n  }\n}\n\n@media (max-width: 768px) {\n  .extra_field_form__container {\n    max-width: 90%;\n  }\n\n  .extra_field_form__input,\n  .extra_field_form__textarea {\n    font-size: 14px;\n  }\n\n  .extra_field_form__actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .extra_field_form__cancel_button,\n  .extra_field_form__submit_button {\n    width: 100%;\n  }\n}\n\n/* *************** */\n.nwepricingdataEditOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.nwepricingdataEdit {\n  background-color: #ffffff;\n  padding: 2rem;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 500px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n  font-family: \"Segoe UI\", sans-serif;\n  height: 500px;\n  overflow: auto;\n}\n\n.nwepricingdataEdit h2 {\n  font-size: 1.25rem;\n  margin-bottom: 1rem;\n  color: #111827;\n}\n\n.nwepricingdataEdit p {\n  font-size: 0.95rem;\n  margin: 0.4rem 0;\n  color: #374151;\n}\n\n.updateButton {\n  background-color: #10b981;\n  color: white;\n  padding: 0.6rem 1.2rem;\n  border: none;\n  border-radius: 6px;\n  margin-top: 1rem;\n  margin-right: 0.5rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.updateButton:hover {\n  background-color: #059669;\n}\n\n.closeButton {\n  background-color: #ef4444;\n  color: white;\n  padding: 0.6rem 1.2rem;\n  border: none;\n  border-radius: 6px;\n  margin-top: 1rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.closeButton:hover {\n  background-color: #dc2626;\n}\n\n@media (max-width: 480px) {\n  .nwepricingdataEdit {\n    padding: 1rem;\n    font-size: 0.85rem;\n  }\n\n  .nwepricingdataEdit h2 {\n    font-size: 1rem;\n  }\n\n  .updateButton,\n  .closeButton {\n    width: 100%;\n    margin-top: 0.75rem;\n  }\n}\n/* ******* */\n.updateexistingprices {\n  background: #fff;\n  padding: 2rem;\n  border-radius: 12px;\n  box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 600px;\n  margin: auto;\n}\n\n.updateexistingprices__title {\n  font-size: 1.5rem;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.updateexistingprices__field {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 1rem;\n}\n\n.updateexistingprices__label {\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n}\n\n.updateexistingprices__input {\n  padding: 0.75rem;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n}\n\n.updateexistingprices__actions {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1.5rem;\n}\n\n.updateexistingprices__save {\n  background-color: #28a745;\n  color: #fff;\n  padding: 0.75rem 1.25rem;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.updateexistingprices__cancel {\n  background-color: #dc3545;\n  color: #fff;\n  padding: 0.75rem 1.25rem;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n/* updare pricing or get  */\n.showupdatePricedata_card {\n  background-color: #fdfdfd;\n  border-radius: 10px;\n  padding: 20px;\n  margin: 20px auto;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 600px;\n}\n\n.showupdatePricedata_title {\n  font-size: 20px;\n  margin-bottom: 15px;\n  color: #333;\n}\n\n.showupdatePricedata_card p {\n  margin: 6px 0;\n  font-size: 14px;\n  color: #444;\n}\n\n.showupdatePricedata_update_button {\n  margin-top: 20px;\n  background-color: #007bff;\n  color: white;\n  padding: 10px 16px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.showupdatePricedata_update_button:hover {\n  background-color: #0056b3;\n}\n.showupdatePricedata_close_button {\n  margin-top: 20px;\n  background-color: #dc3545;\n  color: white;\n  padding: 10px 16px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  margin-left: 8px;\n}\n.showupdatePricedata_close_button:hover {\n  background-color: #c82333;\n}\n/* update extra need */\n.updateextraneed_form {\n  background-color: #fff;\n  padding: 2rem;\n  border-radius: 16px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  max-width: 800px;\n  margin: auto;\n  margin-top: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.updateextraneed_title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #333;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.updateextraneed_grid {\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: 1fr 1fr;\n}\n\n.updateextraneed_grid input[type=\"text\"] {\n  padding: 0.75rem;\n  font-size: 1rem;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.updateextraneed_checkboxLabel {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1rem;\n  color: #444;\n}\n\n.updateextraneed_buttons {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.updateextraneed_updateBtn {\n  background-color: #4caf50;\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  flex: 1;\n}\n\n.updateextraneed_cancelBtn {\n  background-color: #f44336;\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  flex: 1;\n}\n\n@media (max-width: 768px) {\n  .updateextraneed_grid {\n    grid-template-columns: 1fr;\n  }\n\n  .updateextraneed_buttons {\n    flex-direction: column;\n  }\n}\n/* task */\n.salestasks_form {\n  max-width: 800px;\n  margin: 2rem auto;\n  padding: 2rem;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.salestasks_title {\n  font-size: 1.8rem;\n  text-align: center;\n  color: #333;\n}\n\n.salestasks_card {\n  border: 1px solid #ddd;\n  padding: 1.5rem;\n  border-radius: 10px;\n  background: #f9f9f9;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.salestasks_card h3 {\n  font-size: 1.2rem;\n  margin: 0;\n}\n\n.salestasks_card input[type=\"text\"],\n.salestasks_card input[type=\"date\"],\n.salestasks_card input[type=\"time\"] {\n  padding: 0.6rem;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  font-size: 1rem;\n  width: 100%;\n}\n\n.salestasks_checkboxLabel {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1rem;\n}\n\n.salestasks_submitBtn {\n  padding: 10px 15px;\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 1.1rem;\n  cursor: pointer;\n  align-self: center;\n}\n.salestasks_buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n.salestasks_closeBtn {\n  padding: 10px 15px;\n\n  background-color: #f44336;\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 1.1rem;\n  cursor: pointer;\n  align-self: center;\n}\n@media (max-width: 768px) {\n  .salestasks_form {\n    padding: 1rem;\n  }\n}\n\n/* view task css */\n.taskgetData_container {\n  padding: 1rem;\n  background: #f1f5f9;\n  border-radius: 1rem;\n  max-width: 1200px;\n  margin: auto;\n}\n\n.taskgetData_header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.taskgetData_title {\n  font-size: 1.75rem;\n  margin-bottom: 0.5rem;\n}\n\n.taskgetData_closeBtn {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #333;\n}\n\n.taskgetData_card {\n  background: #ffffff;\n  border: 1px solid #ddd;\n  padding: 1rem;\n  margin: 1rem 0;\n  border-radius: 0.75rem;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n}\n\n.taskgetData_taskName {\n  font-size: 1.25rem;\n  margin: 0.5rem 0;\n}\n\n.taskgetData_description {\n  font-size: 1rem;\n  color: #555;\n}\n\n.taskgetData_completed {\n  color: green;\n  font-weight: bold;\n}\n\n.taskgetData_incomplete {\n  color: red;\n  font-weight: bold;\n}\n\n@media (max-width: 768px) {\n  .taskgetData_card {\n    padding: 0.75rem;\n  }\n\n  .taskgetData_title {\n    font-size: 1.5rem;\n  }\n\n  .taskgetData_taskName {\n    font-size: 1.1rem;\n  }\n\n  .taskgetData_description {\n    font-size: 0.95rem;\n  }\n\n  .taskgetData_closeBtn {\n    font-size: 1.25rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .taskgetData_container {\n    padding: 0.5rem;\n  }\n\n  .taskgetData_title {\n    font-size: 1.25rem;\n  }\n\n  .taskgetData_card {\n    margin: 0.75rem 0;\n    padding: 0.5rem;\n  }\n\n  .taskgetData_closeBtn {\n    font-size: 1.1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"other_task_button_container": `OtherTask_other_task_button_container__OpnjB`,
	"extra_field_form__overlay": `OtherTask_extra_field_form__overlay__36eKh`,
	"extra_field_form__container": `OtherTask_extra_field_form__container__UcXcL`,
	"extra_field_form__title": `OtherTask_extra_field_form__title__pbAbJ`,
	"extra_field_form__input": `OtherTask_extra_field_form__input__Klpp9`,
	"extra_field_form__textarea": `OtherTask_extra_field_form__textarea__DHVqI`,
	"extra_field_form__checkbox_group_row": `OtherTask_extra_field_form__checkbox_group_row__8QPm5`,
	"extra_field_form__actions": `OtherTask_extra_field_form__actions__HIP8p`,
	"extra_field_form__cancel_button": `OtherTask_extra_field_form__cancel_button__Xzivn`,
	"extra_field_form__submit_button": `OtherTask_extra_field_form__submit_button__f9Rk2`,
	"extra-field-form__checkbox-row": `OtherTask_extra-field-form__checkbox-row__dbgUN`,
	"nwepricingdataEditOverlay": `OtherTask_nwepricingdataEditOverlay__azcuk`,
	"nwepricingdataEdit": `OtherTask_nwepricingdataEdit__dOU-s`,
	"updateButton": `OtherTask_updateButton__rGdbm`,
	"closeButton": `OtherTask_closeButton__lak5w`,
	"updateexistingprices": `OtherTask_updateexistingprices__quFMv`,
	"updateexistingprices__title": `OtherTask_updateexistingprices__title__+zXI3`,
	"updateexistingprices__field": `OtherTask_updateexistingprices__field__4M70m`,
	"updateexistingprices__label": `OtherTask_updateexistingprices__label__pTsjT`,
	"updateexistingprices__input": `OtherTask_updateexistingprices__input__EGZ74`,
	"updateexistingprices__actions": `OtherTask_updateexistingprices__actions__T2Q3T`,
	"updateexistingprices__save": `OtherTask_updateexistingprices__save__BEZY0`,
	"updateexistingprices__cancel": `OtherTask_updateexistingprices__cancel__I8Gau`,
	"showupdatePricedata_card": `OtherTask_showupdatePricedata_card__JyopA`,
	"showupdatePricedata_title": `OtherTask_showupdatePricedata_title__xRvub`,
	"showupdatePricedata_update_button": `OtherTask_showupdatePricedata_update_button__2SsiZ`,
	"showupdatePricedata_close_button": `OtherTask_showupdatePricedata_close_button__SELXh`,
	"updateextraneed_form": `OtherTask_updateextraneed_form__6eDpX`,
	"updateextraneed_title": `OtherTask_updateextraneed_title__R0vZ+`,
	"updateextraneed_grid": `OtherTask_updateextraneed_grid__FZBCh`,
	"updateextraneed_checkboxLabel": `OtherTask_updateextraneed_checkboxLabel__T7Qdg`,
	"updateextraneed_buttons": `OtherTask_updateextraneed_buttons__6EANp`,
	"updateextraneed_updateBtn": `OtherTask_updateextraneed_updateBtn__bVDtt`,
	"updateextraneed_cancelBtn": `OtherTask_updateextraneed_cancelBtn__vOehZ`,
	"salestasks_form": `OtherTask_salestasks_form__h1sfM`,
	"salestasks_title": `OtherTask_salestasks_title__G9ZY3`,
	"salestasks_card": `OtherTask_salestasks_card__+BkBh`,
	"salestasks_checkboxLabel": `OtherTask_salestasks_checkboxLabel__gigJV`,
	"salestasks_submitBtn": `OtherTask_salestasks_submitBtn__k938+`,
	"salestasks_buttons": `OtherTask_salestasks_buttons__b5+7P`,
	"salestasks_closeBtn": `OtherTask_salestasks_closeBtn__Dsrlj`,
	"taskgetData_container": `OtherTask_taskgetData_container__JmB9t`,
	"taskgetData_header": `OtherTask_taskgetData_header__8Clys`,
	"taskgetData_title": `OtherTask_taskgetData_title__MmETZ`,
	"taskgetData_closeBtn": `OtherTask_taskgetData_closeBtn__9sYc2`,
	"taskgetData_card": `OtherTask_taskgetData_card__dkg6G`,
	"taskgetData_taskName": `OtherTask_taskgetData_taskName__MmZZ+`,
	"taskgetData_description": `OtherTask_taskgetData_description__TLwtm`,
	"taskgetData_completed": `OtherTask_taskgetData_completed__zT8j4`,
	"taskgetData_incomplete": `OtherTask_taskgetData_incomplete__dSmir`
};
export default ___CSS_LOADER_EXPORT___;
